"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkPostDocLoadResourceInstrumentation = void 0;
const instrumentation_1 = require("@opentelemetry/instrumentation");
const version_1 = require("./version");
const core_1 = require("@opentelemetry/core");
const sdk_trace_web_1 = require("@opentelemetry/sdk-trace-web");
const semantic_conventions_1 = require("@opentelemetry/semantic-conventions");
const MODULE_NAME = 'splunk-post-doc-load-resource';
const defaultAllowedInitiatorTypes = ['img', 'script']; //other, css, link
class SplunkPostDocLoadResourceInstrumentation extends instrumentation_1.InstrumentationBase {
    constructor(config = {}) {
        const processedConfig = Object.assign({}, { allowedInitiatorTypes: defaultAllowedInitiatorTypes }, config);
        super(MODULE_NAME, version_1.VERSION, processedConfig);
        this.config = processedConfig;
    }
    init() { }
    enable() {
        if (window.PerformanceObserver) {
            window.addEventListener('load', () => {
                this._startObserver();
            });
        }
    }
    disable() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    _startObserver() {
        this.observer = new PerformanceObserver((list) => {
            if (window.document.readyState === 'complete') {
                list.getEntries().forEach(entry => {
                    // TODO: check how we can amend TS base typing to fix this
                    if (this.config.allowedInitiatorTypes.includes(entry.initiatorType)) {
                        this._createSpan(entry);
                    }
                });
            }
        });
        //apparently safari 13.1 only supports entryTypes
        this.observer.observe({ entryTypes: ['resource'] });
    }
    // TODO: discuss TS built-in types
    _createSpan(entry) {
        if ((0, core_1.isUrlIgnored)(entry.name, this.config.ignoreUrls)) {
            return;
        }
        const span = this.tracer.startSpan(
        //TODO use @opentelemetry/instrumentation-document-load AttributeNames.RESOURCE_FETCH ?,
        // AttributeNames not exported currently
        'resourceFetch', {
            startTime: (0, core_1.hrTime)(entry.fetchStart),
        });
        span.setAttribute('component', MODULE_NAME);
        span.setAttribute(semantic_conventions_1.SemanticAttributes.HTTP_URL, entry.name);
        (0, sdk_trace_web_1.addSpanNetworkEvents)(span, entry);
        //TODO look for server-timings? captureTraceParentFromPerformanceEntries(entry)
        const resEnd = entry['responseEnd'];
        if (resEnd && resEnd > 0) {
            span.end(resEnd);
        }
        else {
            span.end();
        }
    }
}
exports.SplunkPostDocLoadResourceInstrumentation = SplunkPostDocLoadResourceInstrumentation;
//# sourceMappingURL=SplunkPostDocLoadResourceInstrumentation.js.map